<template>
  <b-modal id="requirement-modal" ref="requirementModal" size="lg" @show="retrieveRequirementList">
    <template #modal-header>
      <h5>Requirement List</h5>
      <button type="button" class="btn-popup-close" @click="hideModal"></button>
    </template>
    <template>
      <b-form @submit.prevent>
        <b-row>
          <b-col cols="4" class="d-flex align-items-center mb-4">
            <div class="keyword-label-area mr-3">
              <label for="requirement-list">Type</label>
            </div>
            <b-dropdown id="status-list" class="w-100">
              <template #button-content class="status-list">
                <span>{{ selectedTypeText }}</span>
                <!-- Search Options Label-->
                <span class="icon"></span>
              </template>
              <b-dropdown-item v-for="option in typeFilterOptions" :key="option.value" :value="option.value"
                @click="setType(option.value)">
                {{ option.text }}
              </b-dropdown-item>
            </b-dropdown>
          </b-col>
          <b-col cols="7" class="pr-0">
            <b-input-group size="sm">
              <b-form-input placeholder="Search..." @keyup.enter="reload" v-model="keyword" b-input
                onsubmit="return false;"></b-form-input>
            </b-input-group>
          </b-col>
          <b-col cols="1" class="p-0">
            <button @click="reload" class="modal-search-button"><b-icon icon="search"></b-icon></button>
          </b-col>
        </b-row>
      </b-form>
    </template>
    <b-table head-variant="light" :items="requirement.list" :fields="fields" small class="mb-0 my-table w-100" hover
      outlineless borderless @row-clicked="onRowClicked" align="center">\
      <template #cell(selected)="data">
        <b-form-checkbox v-model="selectedRequirement" :value="data.item" @change="onCheckboxChange(data.item)">
        </b-form-checkbox>
      </template>
    </b-table>

    <div v-if="!requirement.list || requirement.list.length === 0" class="requirement">
      선택 가능한 요구사항이 존재하지 않습니다.
    </div>
    <b-icon class="h1 arrow arrow-left" icon="chevron-left" variant="secondary" @click="goLeft"
      v-if="currentPage > 1"></b-icon>
    <b-icon class="h1 arrow arrow-right" icon="chevron-right" variant="secondary" @click="goRight"
      v-if="currentPage < maxPage"></b-icon>
    <b-pagination v-if="false" v-model="currentPage" :total-rows="total" :per-page="perPage" aria-controls="my-table"
      align="center"></b-pagination>
    <template #modal-footer="{ ok, cancel }">
      <b-button variant="primary" :disabled="isDisabledOkButton" @click="submitRequirements">OK</b-button>
      <b-button variant="secondary" @click="cancel">Cancel</b-button>
    </template>
  </b-modal>
</template>
<script>

export default {
  name: 'RequirementModal',
  props: {
    projectId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      total: 0,
      type: '',
      keyword: '',
      requirement: { list: [] },
      selectedRequirement: null,
      isDisabledOkButton: true,
      fields: [
        { key: 'selected', label: 'Select', thClass: 'text-center selected-column', tdClass: 'text-center' },
        { key: 'id', label: 'ID', thClass: 'text-center id-column', tdClass: 'text-center' },
        { key: 'title', label: 'Title', thClass: 'text-center title-column', tdClass: 'text-start ellipsis' },
        { key: 'creatorName', label: 'Creator Name', thClass: 'text-center creatorName-column', tdClass: 'text-center' }
      ]
    };
  },
  mounted() {
    this.$emit('modal-loaded');
  },
  computed: {
    maxPage() {
      return Math.ceil(this.total / this.perPage);
    },
    typeFilterOptions() {
      const allTypeOption = { text: 'All', value: '' }
      const typeOptions = this.$store.getters['requirement/typeOptions'];
      return [allTypeOption, ...typeOptions];
    },
    selectedTypeText() {
      const findOption = this.typeFilterOptions.find(option => option.value === this.type);
      return findOption ? findOption.text : '';
    },
  },
  methods: {
    goLeft() {
      this.currentPage = this.currentPage - 1;
      this.retrieveRequirementList();
    },
    goRight() {
      this.currentPage = this.currentPage + 1;
      this.retrieveRequirementList();
    },
    reload() {
      this.currentPage = 1; // 검색 시 첫 페이지로 이동
      this.retrieveRequirementList();
    },
    hideModal() {
      this.$refs['requirementModal'].hide();
    },
    setType(value) {
      this.type = value;
      this.reload();
    },
    async retrieveRequirementList() {
      console.log(this.$parent);
      let params = {
        pageNo: this.currentPage,
        pageSize: this.perPage,
        projectId: this.projectId,
        type: this.type
      };

      if (this.keyword !== '') {
        params.keyword = this.keyword;
      }

      try {
        const response = await axios.get('chatter/retrieveRequirementList', {
          params,
          headers: {
            Accept: 'application/json',
            Authorization: accessToken(),
          },
        });

        const body = response.data.body;
        this.requirement.list = body.list;
        this.total = body.total;

      } catch (error) {
        console.error(error);
      }
    },
    showModal() {
      this.$refs.requirementModal.show();
    },
    onRowClicked(item) {
      if (this.selectedRequirement && this.selectedRequirement.id === item.id) {
        item.selected = false;
        this.selectedRequirement = null;
      } else {
        this.requirement.list.forEach(req => req.selected = false);
        item.selected = true;
        this.selectedRequirement = item;
      }
      this.isDisabledOkButton = this.selectedRequirement === null;

      this.onCheckboxChange(item);
    },
    onCheckboxChange(item) {
      if (item.selected) {
        this.requirement.list.forEach(req => {
          if (req.id !== item.id) req.selected = false;
        });
        this.selectedRequirement = item;
      } else {
        this.selectedRequirement = null;
      }
      this.isDisabledOkButton = this.selectedRequirement === null;
    },
    submitRequirements() {
      if (this.selectedRequirement) {
        this.$emit('requirement', this.selectedRequirement);
        this.hideModal();
      }
    },
    async retreiveData() {
      try {
        this.loading = true;
        await this.retrieveRequirementList();

        if (Array.isArray(this.items) && Array.isArray(this.notForShowValues)) {
          this.items = this.items.filter(item => !this.notForShowValues.includes(item.value));
          this.items = this.items.map(item => {
            if (this.selectedValues.includes(item.value)) {
              return { ...item, selected: true };
            } else {
              return { ...item, selected: false };
            }
          });
        }

      } catch (e) {
        this.loading = false;
        console.log(e);
      } finally {
        this.loading = false;
      }
    },
    cancel() {
      this.hideModal();
    }
  }
};
</script>

<style>
.btn-popup-close {
  display: block;
  width: 30px;
  height: 30px;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none"><path d="M22.5 22.5L7.5 7.5" stroke="%232E2E38" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/><path d="M22.5 7.5L7.5 22.5" stroke="%232E2E38" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>') center no-repeat transparent;
  border: none;
}

/* Add your styles here */
#requirement-modal.modal.show .modal-dialog {
  margin: 0 auto;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

#requirement-modal .modal-content {
  border-radius: 20px;
}

#requirement-modal .modal-header {
  align-items: center;
  padding: 2.083vw 2.666rem 1.041vw;
  border-radius: 20px 20px 0 0;
  border-bottom: 0px;
}

#requirement-modal .modal-header h5 {
  margin-bottom: 0 !important;
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 24px;
  font-weight: 700;
  line-height: 150%;
}

#requirement-modal .modal-body {
  padding: 1.041vw 2.666rem 1.041vw 2.666rem;
}

#requirement-modal .modal-footer {
  justify-content: center;
  gap: 0 0.666rem;
  padding: 1.362vh 2.666rem 2.604vw;
  border-top: 0px;
  border-radius: 0 0 20px 20px;
}

#requirement-modal .btn {
  margin: 0;
  border-radius: 10px;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
}

#requirement-modal .btn-primary {
  width: 148px;
  height: 40px;
  background-color: #2E2E38;
  color: #FFE600;
  border-color: transparent;
}

#requirement-modal .btn-primary:hover {
  color: #FFE600;
  background-color: #0D0D17;
  border-color: transparent;
}

#requirement-modal .btn-primary.disabled,
#requirement-modal .btn-primary:disabled {
  color: #9C9CA8;
  background-color: #C4C4CD;
  border-color: transparent;
}

#requirement-modal .modal-footer .btn-secondary {
  width: 148px;
  height: 40px;
  margin: 0;
  border-radius: 10px;
  background: #747480;
  color: #fff;
  border-radius: 10px;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
}

#requirement-modal .modal-footer .btn-secondary:hover {
  justify-content: center;
  background-color: #565662;
}

#requirement-modal .modal-footer .btn-secondary.disabled,
#requirement-modal .modal-footer .btn-secondary:disabled {
  justify-content: center;
  color: #9C9CA8;
  background-color: #C4C4CD;
  border-color: transparent;
}

/* related - tab 메뉴 영역 */
.card.related .card-header {
  padding: 0 2.0833vw 10px;
  border-bottom: 0;
}

.card.related .card-header-tabs {
  gap: 0 2rem;
  margin: 0;
  border-bottom: 1px solid #DDDDE3;
}

.card.related .nav-tabs .nav-item {
  margin-bottom: 0;
}

.card.related .nav-tabs .nav-link {
  margin-bottom: 0;
  border-top-left-radius: unset;
  border-top-right-radius: unset;
}

.card.related .nav-tabs .nav-link {
  padding: 2rem 0.666rem 1.066rem;
  border-color: transparent;
  color: #747480;
  font-family: 'NanumGothic';
  font-size: 18px;
  font-weight: 500;
  line-height: 150%;
}

.card.related .nav-tabs .nav-link:hover,
.card.related .nav-tabs .nav-link:focus {
  border-color: transparent;
}

.card.related .nav-tabs .nav-link.active,
.card.related .nav-tabs .nav-item.show .nav-link {
  border-top-left-radius: 30px;
  color: #2E2E38;
  font-weight: 700;
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: 3px solid #2E2E38;
}

.modal-dialog .modal-content footer.modal-footer {
  display: flex !important;
  justify-content: center;
  align-items: center !important;
}

.modal-body {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}

#chatterModal {
  height: 453px;
  margin: 0px;
}

.modal-body .input-group {
  padding-right: 16px;
}

.modal-body .input-group>.form-control {
  padding: 0.533rem 0.8rem 0.533rem 1.066rem;
  height: 2.666rem;
  border-radius: 10px;
  border: 1px solid #E7E7EE;
  background-color: #F6F6FA;
  font-family: 'NanumGothic';
  color: #2E2E38;
  font-size: 16px;
  font-weight: 400;
  line-height: 150%;
}

.modal-search-button {
  border: none;
  color: #FFE305;
  font-weight: bold;
  padding: 0 1rem;
  background-color: #2E2E38;
  border-radius: 10px;
}


.my-table {
  max-width: 100%;
  max-height: 100%;
  font-size: 1em;
  user-select: none;
}

.columnRate2 {
  width: 2%;
}

.columnRate3 {
  width: 3%;
}

.columnRate10 {
  width: 7%;
}

.columnRate15 {
  width: 15%;
}

.columnRate20 {
  width: 20%;
}

.columnRate25 {
  width: 25%;
}

.columnRate30 {
  width: 30%;
}

.columnRate40 {
  width: 40%;
}

.columnRate50 {
  width: 50%;
}

.columnRate60 {
  width: 60%;
}

.columnRate65 {
  width: 65%;
}

.arrow {
  position: absolute;
  top: 50%;
  opacity: .3;
}

.arrow:hover {
  opacity: 1;
  cursor: pointer;
}

.arrow-left {
  left: 0;
}

.arrow-right {
  right: 0;
}

.custom-style {
  max-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 신규 스타일 추가 */
#requirement-modal.overflow-auto {
  height: 453px !important;
  padding: 1px;
  font-family: 'NanumGothic';
}

#requirement-modal.overflow-auto::-webkit-scrollbar {
  width: 16px;
  border-left: 10px solid transparent;
  background-clip: padding-box;
}

#requirement-modal.overflow-auto::-webkit-scrollbar-track {
  width: 6px;
  background-color: #F6F6FA;
  border-left: 10px solid transparent;
  background-clip: padding-box;
}

#requirement-modal.overflow-auto::-webkit-scrollbar-thumb {
  width: 100%;
  background-color: #C4C4CD;
  border-left: 10px solid transparent;
  background-clip: padding-box;
}

#requirement-modal .table thead tr {
  background-color: transparent;
  box-shadow: 0 -1px 0 0 #DDDDE3, -1px 0 0 0 #DDDDE3, 1px 0 0 0 #DDDDE3;
  border-radius: 10px 10px 0 0;
  border: none;
}

#requirement-modal .table .thead-light th {
  padding: 0.666rem;
  background: #F6F6FA;
  color: #2E2E38;
  text-align: center;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 700;
  line-height: 150%;
}

#requirement-modal .table .thead-light th.selected-column {
  width:5%;
}

#requirement-modal .table .thead-light th.id-column {
  width: 15%;
}

#requirement-modal .table .thead-light th.title-column {
  width: 60%;
}

#requirement-modal .table .thead-light th.creatorName-column {
  width: 20%;
}

#requirement-modal .table .thead-light th:first-child {
  border-radius: 10px 0 0 0;
}

#requirement-modal .table .thead-light th:last-child {
  border-radius: 0 10px 0 0;
}

#requirement-modal .table tbody {
  box-shadow: 0 0 0 1px #DDDDE3;
  border-radius: 0 0 10px 10px;
}

#requirement-modal .table tbody tr {
  box-shadow: 0 1px 0 0 #DDDDE3;
}

#requirement-modal .table tbody tr:last-child {
  box-shadow: none;
  border-radius: 0 0 10px 10px;
}

#requirement-modal .table tbody td {
  padding: 0.666rem;
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
}

#requirement-modal .table tbody td.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 450px; /* 부모 요소의 너비를 100%로 설정 */
  display: block; /* 블록 레벨 요소로 설정하여 max-width 적용 */
}

.modal-search-button {
  border: none;
  color: #FFE305;
  font-weight: bold;
  padding: 0 1rem;
  background-color: #2E2E38;
  border-radius: 10px;
}

.requirement {
  padding: 0.666rem;
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
  text-align: center
}
</style>